import { MediaDevices, PackagePickerType } from '@wix/package-picker-common';
const titleKeyByDevice = {
    [MediaDevices.Desktop]: 'page_footer.money_back_guarantee',
    [MediaDevices.Tablet]: 'page_footer.money_back_guarantee.non_desktop',
    [MediaDevices.Mobile]: 'page_footer.money_back_guarantee.non_desktop',
};
const secondUpgradeTitleKeyByDevice = {
    [MediaDevices.Desktop]: 'page_footer.money_back_guarantee_second_upgrade',
    [MediaDevices.Tablet]: 'page_footer.money_back_guarantee_second_upgrade.non_desktop',
    [MediaDevices.Mobile]: 'page_footer.money_back_guarantee_second_upgrade.non_desktop',
};
const commonContent = {
    titleKey: titleKeyByDevice,
    descKey: 'page_footer.try_14_days',
};
const secondUpgradeCommonContent = {
    titleKey: secondUpgradeTitleKeyByDevice,
    descKey: 'app.second_upgrade_text',
};
const contentByType = {
    [PackagePickerType.Default]: commonContent,
    [PackagePickerType.Sunrise]: commonContent,
    [PackagePickerType.Sandbox]: commonContent,
    [PackagePickerType.Studio]: {
        ...commonContent,
        descKey: 'studio_package_picker.footer.try_wix_studio_free',
    },
    [PackagePickerType.EditorXToStudio]: {
        ...commonContent,
        descKey: 'studio_package_picker.footer.try_wix_studio_free',
    },
    [PackagePickerType.EditorX]: {
        ...commonContent,
        descKey: 'page_footer.try_14_days_editorx',
    },
    [PackagePickerType.Dayful]: {
        ...commonContent,
        descKey: 'page_footer.try_14_days_dayful',
    },
};
export const getContentByScenario = ({ packagePickerType, isSecondUpgrade, }) => {
    if (isSecondUpgrade) {
        return secondUpgradeCommonContent;
    }
    return contentByType[packagePickerType] ?? commonContent;
};
//# sourceMappingURL=getContentByScenario.js.map